import { render, staticRenderFns } from "./DetailKelas.vue?vue&type=template&id=03de3428&"
import script from "./DetailKelas.vue?vue&type=script&lang=js&"
export * from "./DetailKelas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports